import axios from 'axios';
import Cache from '~/src/api/requests/cache';
import { stringify } from 'qs';

const EPG_API_ENDPOINT = process.env.EPG_API_ENDPOINT;

const axiosEpg = axios.create({
    baseURL: EPG_API_ENDPOINT,
});

const epgRequest = Object.create(axiosEpg);

epgRequest.getWithCache = async(url, options) => {
    let params = {};
    if (options) {
        params = options.params;
        options.paramsSerializer = params => {
            return stringify(params);
        };
    }
    const cache = new Cache(EPG_API_ENDPOINT, url, params);
    const dataFromCache = await cache.get();
    if (dataFromCache) {
        return {
            status: 200,
            data: dataFromCache
        };
    } else {
        const result = await axiosEpg.get(url, options);
        cache.set(result.data);
        return result;
    }
};

export default epgRequest;
